import { AppBar, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { PageToolbar } from '$common/app-bar/common/page-toolbar'
import { BackButton } from '../../buttons'

const TitleTypography = styled(Typography)`
  margin-right: 7px;
  flex-grow: 1;
  text-align: right;
`

interface Prop {
  title: string
  onBack: () => any
}

export function AppBarBackTitle({ title, onBack }: Prop) {
  return (
    <AppBar sx={{ maxWidth: '100%' }}>
      <PageToolbar>
        <BackButton onClick={onBack} />
        <TitleTypography color="neutral900" variant="subtitle1">
          {title}
        </TitleTypography>
      </PageToolbar>
    </AppBar>
  )
}
